(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-title"] && !Shopify.designMode) return;
  try {
    
  const initializeCollectionTitleAutoplay = (scope = document) => {
    const roots = [];

    if (scope.matches?.('[data-collection-title-autoplay]')) {
      roots.push(scope);
    }

    roots.push(...scope.querySelectorAll('[data-collection-title-autoplay]'));

    roots.forEach((root) => {
      if (root.collectionTitleAutoplayTimer) {
        window.clearInterval(root.collectionTitleAutoplayTimer);
      }

      const nextButton = root.querySelector('xo-carousel-next button');

      if (!nextButton) {
        return;
      }

      const interval = Number(root.dataset.collectionTitleAutoplay) || 3000;

      root.collectionTitleAutoplayTimer = window.setInterval(() => {
        if (!document.hidden && root.isConnected) {
          nextButton.click();
        }
      }, interval);
    });
  };

  initializeCollectionTitleAutoplay();

  document.addEventListener('shopify:section:load', (event) => {
    initializeCollectionTitleAutoplay(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-collection-title-autoplay]');

    if (root?.collectionTitleAutoplayTimer) {
      window.clearInterval(root.collectionTitleAutoplayTimer);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-v1"]) return;
  try {
    
  const initializePawlyFooter = (scope) => {
    scope.querySelectorAll('[data-pawly-footer]').forEach((footer) => {
      if (footer.hasAttribute('data-footer-ready')) return;
      const mobile = window.matchMedia('(max-width: 767px)');
      const groups = Array.from(footer.querySelectorAll('[data-footer-menu]')).map((group) => {
        const button = group.querySelector('.pawly-footer-menu__toggle');
        const panel = group.querySelector('.pawly-footer-menu__links');
        if (!button || !panel) return null;
        return { button, panel, open: button.getAttribute('aria-expanded') === 'true' };
      }).filter(Boolean);
      const update = () => {
        groups.forEach((group) => {
          const expanded = !mobile.matches || group.open;
          group.panel.hidden = !expanded;
          group.button.setAttribute('aria-expanded', String(expanded));
        });
      };
      groups.forEach((group) => {
        group.button.addEventListener('click', () => {
          if (!mobile.matches) return;
          group.open = !group.open;
          update();
        });
      });
      mobile.addEventListener('change', update);
      update();
      footer.setAttribute('data-footer-ready', '');
    });
  };
  initializePawlyFooter(document);
  document.addEventListener('shopify:section:load', (event) => initializePawlyFooter(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-reels"] && !Shopify.designMode) return;
  try {
    
  const initializePopularReels = (scope) => {
    scope.querySelectorAll('[data-popular-reels]').forEach((root) => {
      if (root.dataset.reelsReady) return;
      root.dataset.reelsReady = 'true';
      const track = root.querySelector('.pawly-reels__track');
      const cards = Array.from(root.querySelectorAll('.pawly-reels__card'));
      const previous = root.querySelector('[data-reels-prev]');
      const next = root.querySelector('[data-reels-next]');
      const pagination = root.querySelector('[data-reels-dots]');
      if (!track || !previous || !next || !pagination || !cards.length) return;
      let positions = [];
      let current = 0;
      const update = () => {
        let nearest = 0;
        positions.forEach((position, index) => {
          if (Math.abs(track.scrollLeft - position) < Math.abs(track.scrollLeft - positions[nearest])) nearest = index;
        });
        current = nearest;
        Array.from(pagination.children).forEach((dot, index) => {
          dot.classList.toggle('is-active', index === current);
          dot.setAttribute('aria-current', index === current ? 'true' : 'false');
        });
      };
      const go = (index) => {
        if (!positions.length) return;
        const target = (index + positions.length) % positions.length;
        track.scrollTo({ left: positions[target], behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      const rebuild = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const firstLeft = cards[0].getBoundingClientRect().left;
        positions = [];
        cards.forEach((card) => {
          const position = Math.min(maximum, Math.max(0, card.getBoundingClientRect().left - firstLeft));
          if (!positions.length || Math.abs(position - positions[positions.length - 1]) > 2) positions.push(position);
        });
        pagination.replaceChildren();
        positions.forEach((position, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pawly-reels__dot';
          dot.setAttribute('aria-label', (index + 1) + ' / ' + positions.length);
          dot.addEventListener('click', () => go(index));
          pagination.appendChild(dot);
        });
        previous.disabled = positions.length < 2;
        next.disabled = positions.length < 2;
        update();
      };
      previous.addEventListener('click', () => go(current - 1));
      next.addEventListener('click', () => go(current + 1));
      track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(rebuild).observe(track);
      else window.addEventListener('resize', rebuild);
      rebuild();
    });
  };
  initializePopularReels(document);
  document.addEventListener('shopify:section:load', (event) => initializePopularReels(event.target));

  } catch(e) { console.error(e); }
})();
})();
